import React, { useState } from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";

function Checkbox(props) {
  const { label, name, isChecked, ...rest } = props;
  const [isCheckedLocal, setIsCheckedLocal] = useState(isChecked);

  const handleCheckboxChange = () => {
    setIsCheckedLocal(!isCheckedLocal);
  };

  return (
    <React.Fragment>
      <div className="form-control-customed">
        <div style={{ float: "left", width: "23px" }}>
          <Field
            type="checkbox"
            name={name}
            value={isChecked}
            checked={isCheckedLocal}
            onChange={handleCheckboxChange}
            className="form-check-input"
          />
          <div style={{ clear: "both" }}></div>
        </div>
        <div style={{ float: "left" }}>
          <span className="text-sm">{label}</span>
        </div>
        {/* <ErrorMessage component={TextError} name={name} /> */}
      </div>
    </React.Fragment>
  );
}

export default Checkbox;
